import {toggleGuide} from "../lib/common/guide";

toggleGuide(".search-by", ".search-drop-option", "show");

